import React from 'react';
import SystemEmailTemplatesPage from '../settings/SystemEmailTemplatesPage';
import type { EmbeddedInConfigurationHub } from './models';

const SystemEmailTemplatesModule: React.FC<EmbeddedInConfigurationHub> = ({ embedded = true }) => (
  <SystemEmailTemplatesPage embedded={embedded} />
);

export default SystemEmailTemplatesModule;
